import React, { ReactNode } from 'react';
import { Inline } from '../Layout';
import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';
import { styled } from '../theming';
import {
  FormElementsColorProps,
  FormElementsSize,
  FormElementsStatePropsLegacy,
} from './sharedTypes';
import { HelperTextIcon } from './HelperTextIcon';
import { ShortText, ShortTextSize } from '../Typography';
import { disabledColors, readOnlyColors, stateColors } from './stylesHelper.styles';

const sizes = {
  default: tokens.size.x8,
  large: tokens.size.x10,
};

const StyledAdditionalTextContainer = styled(Inline)`
  min-height: ${({ size }) => sizes[size as FormElementsSize]};
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const AdditionalTextContainer = ({
  children,
  size,
}: {
  children: ReactNode;
  size: FormElementsSize;
}) => (
  <StyledAdditionalTextContainer gap={tokens.space.x2} alignItems="leading" size={size}>
    {children}
  </StyledAdditionalTextContainer>
);

const StyledText = styled(ShortText)<{
  state: FormElementsStatePropsLegacy;
  size: ShortTextSize;
  color: FormElementsColorProps;
  disabled?: boolean;
  readOnly?: boolean;
}>`
  font-size: ${({ size }) => tokens.typography.shortText[size as ShortTextSize].fontSize};
  color: ${({ theme, state, color, disabled, readOnly }) => {
    if (readOnly) return readOnlyColors(theme).additionalTextColor;
    if (disabled) return disabledColors(theme).additionalTextColor;

    return stateColors(theme, state, color).additionalTextColor;
  }};
`;

export const AdditionalText = ({
  size = 'default',
  state,
  color = 'default',
  additionalTextId,
  additionalText,
  disabled,
  readOnly = false,
}: {
  state: FormElementsStatePropsLegacy;
  size?: FormElementsSize;
  color?: FormElementsColorProps;
  additionalTextId: string;
  disabled?: boolean;
  readOnly?: boolean;
  additionalText: string;
}) => (
  <AdditionalTextContainer size={size}>
    <HelperTextIcon size={size} state={state} color={color} />
    <StyledText
      id={additionalTextId}
      size={size === 'default' ? 'small' : 'default'}
      state={state}
      color={color}
      aria-live="polite"
      disabled={disabled}
      readOnly={readOnly}
    >
      {additionalText}
    </StyledText>
  </AdditionalTextContainer>
);
